import { createAction, handleActions } from 'redux-actions'

const startFetching = createAction('SCREENS/SUB_PROJECT/OVERVIEW/START_FETCHING')
const finishFetching = createAction('SCREENS/SUB_PROJECT/OVERVIEW/FINISH_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [startFetching]: () => true,
    [finishFetching]: () => false,
  },
  defaultState,
)

export { startFetching, finishFetching, reducer }
